export default __webpack_public_path__ + "static/media/sugar_002.1c379b03.jpg";